import React, { useState } from "react";
import { Copy, Check, QrCode } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { toast } from "sonner";
import { formatBRL } from "@/lib/api";

export function PixPaymentBlock({ pix }) {
  const [copied, setCopied] = useState(false);
  if (!pix || !pix.brcode) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(pix.brcode);
      setCopied(true);
      toast.success("Código PIX copiado!");
      setTimeout(() => setCopied(false), 2500);
    } catch {
      toast.error("Não foi possível copiar. Selecione o código manualmente.");
    }
  };

  return (
    <div className="rounded-2xl border-2 border-green-300 bg-green-50/70 p-5" data-testid="pix-payment-block">
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-green-800 font-semibold">
        <QrCode className="h-3.5 w-3.5" />
        Pagar via PIX (recomendado)
      </div>
      <div className="text-center mt-3">
        <div className="text-[11px] uppercase tracking-widest text-stone-500 font-semibold">Valor total</div>
        <div className="brand-text font-display text-4xl font-extrabold mt-1" data-testid="pix-amount">
          {formatBRL(pix.amount || 0)}
        </div>
      </div>
      <div className="mt-4 flex justify-center">
        <div className="p-3 bg-white rounded-xl border border-green-200 shadow-sm">
          <QRCodeSVG
            value={pix.brcode}
            size={200}
            level="M"
            includeMargin={false}
            data-testid="pix-qrcode"
          />
        </div>
      </div>
      <button
        type="button"
        onClick={handleCopy}
        data-testid="copy-pix-code-btn"
        className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-full bg-green-600 hover:bg-green-700 text-white font-semibold text-sm py-3 transition-colors"
      >
        {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
        {copied ? "Copiado!" : "Copiar código PIX"}
      </button>
      <div className="mt-2 text-[11px] text-stone-600 text-center">
        Beneficiário: <strong>{pix.beneficiary_name}</strong>
      </div>
    </div>
  );
}
